export default {"src":"/_next/static/media/backtotop.840c29c0.svg","height":106,"width":106,"blurWidth":0,"blurHeight":0};